import React from "react"
import { useTranslation } from "react-i18next"
import { formatVars } from "../../helpers/translation"

const DateDisplay = ({ className, date, children, extraVars }) => {
  const {
    i18n: { language },
  } = useTranslation("generic")

  const formatter = new Intl.DateTimeFormat(language, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })

  return (
    <div className={className}>
      {formatVars(language, children, {
        DATE: formatter.format(date),
        ...extraVars,
      })}
    </div>
  )
}

export default DateDisplay
